import React from "react";

import buttonBg from "../img/trag-button-bg.svg"
import lineStar from "../img/overlays/trag-line-star.svg"
import ov1 from "../img/overlays/trag-ov-1.svg"
import ov2 from "../img/overlays/trag-ov-2.svg"
import ov3 from "../img/overlays/trag-ov-3.svg"
import ov4 from "../img/overlays/trag-ov-4.svg"
import ov5 from "../img/overlays/trag-ov-5.svg"
import ov6 from "../img/overlays/trag-ov-6.svg"
import ov7 from "../img/overlays/trag-ov-7.svg"
import ov8 from "../img/overlays/trag-ov-8.svg"
import ov9 from "../img/overlays/trag-ov-9.svg"

import lineStarMob from "../img/overlays/trag-line-star-mob.svg"


import "../style/trajetoria.css"

function Trajetoria() {
    return (
        <div className="trajetoria-container">
            <img src={ov1} alt="" className="ov ov1" />
            <img src={ov2} alt="" className="ov ov2" />
            <img src={ov3} alt="" className="ov ov3" />
            <img src={ov4} alt="" className="ov ov4" />
            <img src={ov5} alt="" className="ov ov5" />
            <img src={ov6} alt="" className="ov ov6" />
            <img src={lineStar} alt="" className="ov line-star desk" />
            <img src={lineStarMob} alt="" className="ov line-star mob" />
            <div className="text-wrapper">
                <b>Acreditamos que a educação pode transformar vidas. Nossos números refletem esse impacto.</b>
                <a href="#">
                    <svg width="300" viewBox="0 0 406 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                        <path d="M390.569 54.2658C265.357 61.0117 139.822 61.0117 14.6097 54.2658C8.75846 53.935 2.57201 49.5336 1.53809 44.5425C-0.512697 34.5555 -0.512697 24.7698 1.53809 14.7828C2.57201 9.79165 8.75846 5.39506 14.6097 5.05944C139.822 -1.68648 265.357 -1.68648 390.569 5.05944C396.42 5.39026 402.607 9.79165 403.641 14.7828C405.691 24.7698 405.691 34.5555 403.641 44.5425C402.607 49.5336 396.42 53.9302 390.569 54.2658Z" fill="#FF6C02"/>
                    </svg>

                    <span>Conheça Nossa Trajetória</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19" viewBox="0 0 28 19" fill="none" className="arrow">
                        <path d="M17.1713 17.9845C16.6269 17.4401 16.6269 16.5606 17.1713 16.0161L22.574 10.5855H1.39603C0.628206 10.5855 -1.52588e-05 9.95729 -1.52588e-05 9.18946C-1.52588e-05 8.42164 0.628206 7.79342 1.39603 7.79342H22.574L17.1574 2.37677C16.6129 1.83231 16.6129 0.952801 17.1574 0.408343C17.7018 -0.136114 18.5813 -0.136114 19.1258 0.408343L26.9436 8.21223C27.4881 8.75669 27.4881 9.6362 26.9436 10.1807L19.1398 17.9845C18.5953 18.515 17.7018 18.515 17.1713 17.9845Z" fill="white"/>
                    </svg>
                </a>
            </div>
            <div className="cards-grid">
                <div className="card orange">
                    <b>+800 MIL</b>
                    <span>ALUNOS <br />ATENDIDOS</span>
                </div>
                <div className="card green">
                    <b>+30 MIL</b>
                    <span>EDUCADORES <br />CAPACITADOS</span>
                </div>
                <div className="card cyan">
                    <b>2.500</b>
                    <span>ESCOLAS <br />PARCEIRAS</span>
                </div>
                <div className="card yellow">
                    <span>PRESENÇA EM</span>
                    <b>+500</b>
                    <span>MUNICÍPIOS</span>
                </div>

                <span className="line blue">ATUAÇÃO EM 23 ESTADOS BRASILEIROS</span>

                <span className="line green">EXPANSÃO INTERNACIONAL (PORTUGAL)</span>
            </div>

            <img src={ov7} alt="" className="ov ov7" />
            <img src={ov8} alt="" className="ov ov8" />
            <img src={ov9} alt="" className="ov ov9" />
        </div>
    )
}

export default Trajetoria